import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const RegulatoryLifeCycle = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Regulatory Life Cycle', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Regulatory Life Cycle" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
             <section class="service-details section-space">
                   <div class="container">
                       <div class="row flex-xl-row flex-column-reverse">
                           <div class="col-xl-4">
                               <div class="sidebar sidebar-rr-sticky">
                                   <div class="sidebar__widget-service mb-30">
                                   <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
                                   <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i> </Link>
                                   <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>
       
                                   </div>
       
                                   <div class="sidebar__widget-contact__service text-center">
                                       <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
                                       <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>
       
                                       <Link to="/contact-us#" class="rr-btn">
                                           <span class="btn-wrap">
                                               <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                               <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                                           </span>
                                       </Link>
                       </div>
                               </div>
                           </div>
                           <div class="col-xl-8">
                               <div class="service-details__content">
                                   <div class="service-details__content-media mb-20">
                                       <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="img not found"/>
                                   </div>
                                   <div className="content-container">
                                    <h3 className="section-title">
                                        <i className="fa-solid fa-sitemap text-primary"></i> Regulatory Life Cycle
                                    </h3>
                                    <p className="content-description">
                                        Medical devices are subject to regulation worldwide, but definitions and classifications can differ across regions. As a result, the necessary regulatory activities may vary depending on the market. 
                                        To navigate these differences effectively, it is advantageous to include your target markets in your regulatory plan(s) early on. This approach enables better planning of activities, ensuring smoother global registrations and a faster time to market.
                                    </p>

                                    <div className="highlight-section">
                                        <h4 className="highlight-title">
                                        <i className="fa-solid fa-building text-secondary"></i> SQUARE MEDTECH Expertise in Regulatory Life Cycle
                                        </h4>
                                        <p className="highlight-description">
                                        SQUARE MEDTECH assists medical device companies in meeting the latest comprehensive requirements and compliance standards throughout the entire lifecycle of their products, globally.
                                        </p>
                                    </div>

                                    <h4 className="section-title mt-4">
                                        <i className="fa-solid fa-handshake text-success"></i> How SQUARE MEDTECH Can Support in Regulatory Life Cycle
                                    </h4>
                                    <div className="support-section">
                                        <ul className="support-list">
                                        <li className="support-item">
                                            <i className="fa-solid fa-file-alt text-info"></i> Assisting with all technical documentation
                                        </li>
                                        <li className="support-item">
                                            <i className="fa-solid fa-route text-warning"></i> Regulatory pathways planning
                                        </li>
                                        <li className="support-item">
                                            <i className="fa-solid fa-notes-medical text-primary"></i> Planning and reporting clinical evaluations
                                        </li>
                                        <li className="support-item">
                                            <i className="fa-solid fa-database text-secondary"></i> Managing clinical investigation planning, data management, execution, and reporting
                                        </li>
                                        <li className="support-item">
                                            <i className="fa-solid fa-globe text-success"></i> Documenting target market requirements in regulatory plans
                                        </li>
                                        <li className="support-item">
                                            <i className="fa-solid fa-check-circle text-danger"></i> Conducting qualification and classification for each target market
                                        </li>
                                        <li className="support-item">
                                            <i className="fa-solid fa-cogs text-info"></i> Providing support in design and development processes
                                        </li>
                                        </ul>
                                    </div>
                                    </div>

                               </div>
                           </div>
                       </div>
                   </div>
               </section>
       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Regulatory Life Cycle Services:</h4>
                    <ul class="color-white mb-0">
                    <li>Technical documentation</li>
                    <li>Clinical Evaluations Planning</li>
                    <li>Clinical Evaluations Reporting</li>
                    </ul>

                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Regulatory Life Cycle Services:</h4>
                    <ul class="color-white mb-0">
                    <li>Support in Design Processes</li>
                    <li>Support in Development Processes</li>
                    <li>Documenting target market requirements </li>
                    </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
